import { useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '恋爱', path: '/category/love' },
  { label: '奇幻', path: '/category/fantasy' },
  { label: '动作', path: '/category/action' },
  { label: '悬疑', path: '/category/suspense' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobile = useCallback(() => {
    setMobileOpen(false);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group" onClick={closeMobile}>
            <span className="font-heading text-2xl font-bold tracking-tight text-primary-600">
              韩国漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : isHome && !scrolled
                      ? 'text-white hover:text-white/80'
                      : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isHome && !scrolled
                  ? 'bg-white/20 text-white hover:bg-white/30'
                  : 'bg-primary-500 text-white hover:bg-primary-600'
              }`}
            >
              <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center" />
              搜漫画
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl transition-colors ${
                isHome && !scrolled ? 'text-white' : 'text-foreground-800'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={closeMobile}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button className="flex items-center justify-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer mt-2">
              <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center" />
              搜漫画
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}